import "./pwc-accordion-divider.js";
import "./pwc-expandable.js";
import "../p-slot.component-Cn2P7TaX.js";
import { P as u } from "../pwc-element-CZs0VuUW.js";
import "./pwc-template.js";
import { x as m, c as v } from "../lit-element-8JrrHldg.js";
import { P as p } from "../pwc-component-size.enum-ldIKEMHl.js";
import { p as f } from "../pwcProperty-CTLG9yrF.js";
import { c as P } from "../clsx-DB4S2d7J.js";
import { n as h } from "../property-4FoNj0Pi.js";
import { a as b } from "../query-C42EGI_8.js";
import { o as r } from "../if-defined-Cd-e8xtV.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let y;
function g(e) {
  return (t, i) => b(t, i, { get() {
    return (this.renderRoot ?? y ?? (y = document.createDocumentFragment())).querySelectorAll(e);
  } });
}
var n = /* @__PURE__ */ ((e) => (e.Default = "default", e.Divided = "divided", e.Raised = "raised", e.Bordered = "bordered", e))(n || {}), w = Object.defineProperty, x = Object.getOwnPropertyDescriptor, a = (e, t, i, d) => {
  for (var s = d > 1 ? void 0 : d ? x(t, i) : t, l = e.length - 1, c; l >= 0; l--)
    (c = e[l]) && (s = (d ? c(t, i, s) : c(s)) || s);
  return d && s && w(t, i, s), s;
};
let o = class extends u {
  constructor() {
    super(...arguments), this.slotControlled = ["default"], this._handleExpandableOpened = (e) => {
      this.disabled || !this.singleOpen || this.expandablePanels.forEach((t) => {
        t !== e.target && t.close();
      });
    };
  }
  openAll() {
    this.expandablePanels.forEach((e) => e.open());
  }
  closeAll() {
    this.expandablePanels.forEach((e) => e.close());
  }
  openById(e) {
    const t = this._getPanel(e);
    t && (t.open(), this.emit("p-accordion-item-opened", { detail: { id: e } }));
  }
  closeById(e) {
    const t = this._getPanel(e);
    t && (t.close(), this.emit("p-accordion-item-closed", { detail: { id: e } }));
  }
  _getPanel(e) {
    return Array.from(this.expandablePanels).find((t) => t.id === e);
  }
  render() {
    var t;
    let e = this.appearance;
    return this.appearance === n.Divided && (e = n.Default), m`<div
      class="${P("PwcAccordion", {
      "PwcAccordion--disabled": this.disabled,
      "PwcAccordion--no-gap": this.appearance === n.Default || this.appearance === n.Divided,
      "PwcAccordion--inset-dividers": this.insetDividers,
      "PwcAccordion--size-sm": this.size === p.Small,
      "PwcAccordion--size-md": this.size === p.Medium,
      "PwcAccordion--size-lg": this.size === p.Large
    })}"
      @p-opened="${this._handleExpandableOpened}"
    >
      <p-slot .host=${this}></p-slot>
      ${!this.slotted.default && this.items ? (t = this.items) == null ? void 0 : t.map(
      (i) => m`<pwc-expandable
                id=${r(i.id || void 0)}
                title=${r(i.title || void 0)}
                content=${r(i.content || void 0)}
                icon=${r(i.icon || void 0)}
                defaultOpen=${r(i.defaultOpen || void 0)}
                size=${r(this.size || void 0)}
                appearance=${r(e || void 0)}
                disabled=${r(this.disabled || void 0)}
              ></pwc-expandable>

              ${this.appearance === n.Divided ? m`<pwc-accordion-divider />` : null}`
    ) : null}
    </div>`;
  }
};
a([
  h({ type: Array })
], o.prototype, "items", 2);
a([
  f({ type: String, default: n.Default })
], o.prototype, "appearance", 2);
a([
  f({ type: String, default: p.Medium })
], o.prototype, "size", 2);
a([
  h({ type: Boolean, attribute: "single-open" })
], o.prototype, "singleOpen", 2);
a([
  h({ type: Boolean, attribute: "inset-dividers" })
], o.prototype, "insetDividers", 2);
a([
  f({ type: Boolean, default: !1 })
], o.prototype, "disabled", 2);
a([
  g("pwc-expandable")
], o.prototype, "expandablePanels", 2);
o = a([
  v("pwc-accordion")
], o);
export {
  o as PwcAccordion
};
